import React from "react"
import Helmet from "react-helmet"

import Project from "../components/project"

const Work = ( {data} ) => (
  <div>
    <Helmet        
      title="Some examples of my past work"
      meta={[
        {
          name: 'description', content: 'The portfolio of work of a freelance web developer and designer | Neil Rudd',
        },
      ]} 
      bodyAttributes={{class: '__static' }} />
    <div className="white">
      {/* <div className="wrapper">
        <h2 className="heading" data-tag="portfolio">
          <span>
            My portfolio work
          </span>
        </h2>
      </div> */}
      {data.allMarkdownRemark.edges.map(({node}, index) => (
        <Project key={index} data={node} />
      ))}     
    </div>
  </div>
)

export default Work

export const query = graphql`
  query portfolioItems {
    allMarkdownRemark(
      filter: {
        frontmatter: {
          layout: {eq: "Portfolio"}
        }
      }
      sort: { 
        fields: [frontmatter___title], order: ASC 
      }
      ) {
      edges {
        node {
          frontmatter {
            title
            overview
            website
            hero {
              publicURL
            }
            tags         
            collaborators {
              service
              name
              website
            }
          }        
          html
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/work.js